import axios from "axios";

/**
 * Dedicated axios instance for the employee portal.
 * - withCredentials: cookies (rrbros_emp_session) are HTTP-only and sent automatically.
 * - Base URL is derived from env — never hard-coded.
 */
export const employeeApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 20000,
});

export const empLogin = async (user_id, password) => {
  const { data } = await employeeApi.post("/employee/login", { user_id, password });
  return data;
};

export const empLogout = async () => {
  await employeeApi.post("/employee/logout");
};

export const empMe = async () => {
  const { data } = await employeeApi.get("/employee/me");
  return data;
};

export const empChangePassword = async (
  current_password,
  new_password,
  confirm_new_password
) => {
  const { data } = await employeeApi.post("/employee/change-password", {
    current_password,
    new_password,
    confirm_new_password,
  });
  return data;
};

export const empAvailability = async (pickup_point, start_datetime, end_datetime) => {
  const { data } = await employeeApi.post("/employee/availability", {
    pickup_point,
    start_datetime,
    end_datetime,
  });
  return data;
};
